<div
  class="w-full bg-gris-4 rounded p-4 flex flex-col gap-2 border border-gris-3"
>
  <!-- Header row (clickable) -->
  <div
    (click)="toggle()"
    (keydown.enter)="toggle()"
    (keydown.space)="$event.preventDefault(); toggle()"
    [attr.aria-expanded]="expanded"
    class="flex items-center w-full cursor-pointer"
    role="button"
    tabindex="0"
  >
    <div class="size-2 bg-vert-1 rounded-full mr-3"></div>

    <div class="flex-1 min-w-0">
      <p
        [title]="$safeNavigationMigration(round?.name)"
        class="fg-noir-2-contour text-sm truncate"
      >
        {{ round?.name }}
      </p>
      <p class="fg-gris-1 text-sm">
        {{ round?.households?.length || 0 }}
        {{ 'navbar.foyer_s' | translate | lowercase }}
      </p>
    </div>

    <div class="flex items-center gap-2 ml-2 text-xs">
      <button
        (click)="startRename($event)"
        class="p-1 rounded bg-gris-4 border border-gris-3 fg-gris-3 flex items-center justify-center size-9 hover:bg-gris-3 transition"
      >
        <span class="material-icons">edit</span>
      </button>
      <button
        (click)="$event.stopPropagation(); requestDelete()"
        class="p-1 rounded"
      >
        <span class="material-icons">delete</span>
      </button>
      <span class="material-icons ml-2">keyboard_arrow_down</span>
    </div>
  </div>

  @if (editingName) {
    <!-- Rename inline -->
    <div class="flex items-center gap-2">
      <input
        [formControl]="nameControl"
        class="flex-1 px-2 py-1 text-sm border-2 border-gray-300 rounded-md focus:outline-none focus:!border-[#8ABD27]"
        (keydown.enter)="confirmRename()"
        (keydown.escape)="cancelRename($event)"
      />
      <button
        class="focus:!bg-[#8ABD27] p-2 rounded bg-vert-3 border-2 fg-vert-1 border-vert-1 disabled:!bg-[#eee] disabled:!border-[#eee] disabled:!text-gray-400"
        (click)="confirmRename()"
        [disabled]="nameControl.invalid"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="3"
          stroke="currentColor"
          class="size-4"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m4.5 12.75 6 6 9-13.5"
          />
        </svg>
      </button>
    </div>
  }

  <!-- Collapsible list of households (reuse existing item component) -->
  @if (expanded) {
    <div class="pt-2">
      @if (!round?.households?.length) {
        <div
          class="text-sm text-gray-400 text-center p-4 border-2 border-dashed rounded-lg"
        >
          {{ 'delivery_round.no_household_in_round' | translate }}
        </div>
      }

      @for (
        household of round?.households;
        let j = $index;
        track household.id
      ) {
        <item-delivery-round-household
          [household]="household"
          [position]="j"
          [color]="'bleu'"
          [isFirst]="j === 0"
          [isLast]="j === (round?.households?.length || 0) - 1"
          [totalHouseholds]="round?.households?.length || 0"
          (dragStarted)="onHouseholdAction($event)"
          (dragEnded)="onHouseholdAction($event)"
          (dropped)="onHouseholdAction($event)"
          (positionChanged)="onHouseholdAction($event)"
        ></item-delivery-round-household>
      }
    </div>
  }
</div>
